import { enqueueSnackbar } from 'notistack';
import { create } from 'zustand';

import { WhitelabelState } from 'src/types/whitelabel';
import { whitelabelRepository } from 'src/repositories/whitelabel/whitelabel.repository';

type Actions = {
  setLoading: (loading: boolean) => void;
  fetchWhitelabel: (shopping: string) => Promise<void>;
};

const initialValues: WhitelabelState = {
  whitelabel: null,
  loading: false,
  error: null,
};

export const useWhitelabelStore = create<WhitelabelState & Actions>((set) => ({
  ...initialValues,

  setLoading: (loading: boolean) => set({ loading }),

  fetchWhitelabel: async (host: string) => {
    set({ loading: true, error: null });
    try {
      const whitelabel = await whitelabelRepository.getByShoppingId(host);
      set({ whitelabel, loading: false });
    } catch (error) {
      enqueueSnackbar('Erro ao buscar informações de whitelabel', { variant: 'error' });
      set({ loading: false, error: error.message, whitelabel: null });
    }
  },
}));
